exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ModulesTreemap__container{align-items:stretch;display:flex;height:100%;position:relative;width:100%}.ModulesTreemap__map{flex:1}.ModulesTreemap__sidebarGroup{font:var(--main-font);margin-bottom:20px}.ModulesTreemap__showOption{margin-top:5px}.ModulesTreemap__activeSize{font-weight:700}.ModulesTreemap__foundModulesInfo{display:flex;font:var(--main-font);margin:8px 0 0}.ModulesTreemap__foundModulesInfoItem+.ModulesTreemap__foundModulesInfoItem{margin-left:15px}.ModulesTreemap__foundModulesContainer{margin-top:15px;max-height:600px;overflow:auto}.ModulesTreemap__foundModulesChunk+.ModulesTreemap__foundModulesChunk{margin-top:15px}.ModulesTreemap__foundModulesChunkName{cursor:pointer;font:var(--main-font);font-weight:700;margin-bottom:7px}.ModulesTreemap__foundModulesList{margin-left:7px}", ""]);

// exports
exports.locals = {
	"container": "ModulesTreemap__container",
	"map": "ModulesTreemap__map",
	"sidebarGroup": "ModulesTreemap__sidebarGroup",
	"showOption": "ModulesTreemap__showOption",
	"activeSize": "ModulesTreemap__activeSize",
	"foundModulesInfo": "ModulesTreemap__foundModulesInfo",
	"foundModulesInfoItem": "ModulesTreemap__foundModulesInfoItem",
	"foundModulesContainer": "ModulesTreemap__foundModulesContainer",
	"foundModulesChunk": "ModulesTreemap__foundModulesChunk",
	"foundModulesChunkName": "ModulesTreemap__foundModulesChunkName",
	"foundModulesList": "ModulesTreemap__foundModulesList"
};